import React, {Component} from 'react';
import './IntroSplash.css';

class PrintDisclaimer extends Component {

  render() {
    return (
      <div className="introPanel print-only">
        <div className="disclaimer">
          Disclaimer: This map is a snapshot generated from Victorian Government and Bureau of Meteorology data. This
          material may be of assistance to you but the State of Victoria does not guarantee that the publication is
          without flaw of any kind or is wholly appropriate for your particular purposes and therefore disclaims all
          liability for error, loss or damage which may arise from reliance upon it. All persons accessing this
          information should make appropriate enquiries to assess the currency of the data.
        </div>
      </div>
    );
  }
}

export default PrintDisclaimer;



// WEBPACK FOOTER //
// ./src/components/PrintDisclaimer.js